import React from 'react'
import PersonalData from './Tabs/PersonalData.js'
import Motivation from './Tabs/Motivation.js';
import WorkExperiences from './Tabs/WorkExperiences.js'
import Salary from './Tabs/Salary.js'
import Educations from './Tabs/Educations.js'
import Capabilities from './Tabs/Capabilities.js'
import JobPreferences from './Tabs/JobPreferences.js'
import Confirmation from './Tabs/Confirmation.js';
import { getTranslation } from '../Utilities/GetTranslation.js';
    
const applyJobTabs = 
[
    {name: getTranslation("sns.webparts.jobapply.personaldata"), component: <PersonalData/>, id: "personaldata"},
    {name: getTranslation("sns.webparts.jobapply.motivation"), component: <Motivation/>, id: "motivation"},
    {name: getTranslation("sns.webparts.jobapply.experiences"), component: <WorkExperiences/>, id: "workexperiences"},
    {name: getTranslation("sns.webparts.jobapply.salary"), component: <Salary/>, id: "salary"},
    {name: getTranslation("sns.webparts.jobapply.educations"), component: <Educations/>, id: "educations"},
    {name: getTranslation("sns.webparts.jobapply.capabilities"), component: <Capabilities/>, id: "capabilities"},
    {name: getTranslation("sns.webparts.jobapply.preferences"), component: <JobPreferences/>, id: "jobpreferences"},
    {name: getTranslation("sns.webparts.jobapply.confirmation"), component: <Confirmation/>, id: "confirmation"}
]

export { applyJobTabs }


// WEBPACK FOOTER //
// ./src/Components/ApplyJobTabs.js